export default __webpack_public_path__ + "static/media/service-and-tools.81c939b3.webp";